import React, { FC, useCallback, useMemo } from 'react';
import { Dropdown, DropdownItem } from 'fronton-react';
import { useDispatch, useSelector } from 'react-redux';
import { REGION_ID } from 'common/constants';
import { getActiveRegionId } from 'features/active-region/ducks/selectors';
import { activeRegionActions } from 'features/active-region';
import { analyticsUtils } from 'utils';
import { regionChooserStyle, storesStyle } from './style';
import { StoresList } from './stores-list';
import { getStoresByRegion, getStoresList } from './ducks/get-stores';

const compareAscending = (a?: string, b?: string) => {
  if (a && b) {
    return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
  }
  return 0;
};

const compareByTopMscSpb = (id1: string, id2: string) =>
  id1 === REGION_ID.MOSCOW || (id1 === REGION_ID.SPB && id2 !== REGION_ID.MOSCOW) ? -1 : 1;

export const Stores: FC = () => {
  const activeRegionId = useSelector(getActiveRegionId) || '';
  const storesByRegions = useSelector(getStoresList);
  const stores = useSelector(getStoresByRegion(activeRegionId));
  const sortedStores = [...stores].sort((a, b) => compareAscending(a.name, b.name));
  const regions = useMemo(
    () =>
      storesByRegions
        ? Object.entries(storesByRegions)
            .map(([regionId, { name = '' }]) => ({ id: regionId, name }))
            .sort((a, b) => compareAscending(a.name, b.name))
            .sort((a, b) => compareByTopMscSpb(a.id, b.id))
        : [],
    [storesByRegions],
  );
  const dispatch = useDispatch();
  const changeRegion = useCallback(
    (selected: string | null) => {
      analyticsUtils.sendEvent('GA:clickButton', {
        elementType: 'button',
        elementBlock: 'shopPage',
        elementText: `chooseRegion / ${regions.find((r) => r.id === selected)?.name}`, // chooseRegion / текущий регион
        elementName: 'list', // название блока
      });
      dispatch(activeRegionActions.setActiveRegionId(selected || ''));
    },
    [dispatch, regions],
  );

  return (
    <div className={storesStyle} data-qa="stores">
      <div className={regionChooserStyle}>
        <Dropdown closeOnSelect value={activeRegionId} size="l" onSelect={changeRegion}>
          {regions.map(({ id, name }) => (
            <DropdownItem text={name} value={id} key={id} />
          ))}
        </Dropdown>
      </div>
      <StoresList stores={sortedStores} storesRegionId={activeRegionId} data-qa="stores-list" />
    </div>
  );
};
